import { animate, state, style, transition, trigger } from '@angular/animations';

export const hatchFade = trigger('hatchFade', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('0.25s ease-in-out', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        animate('0.15s ease-in-out', style({ opacity: 0 }))
    ])
])

export const dropAnimarion = trigger('slideHeight', [
  state('void', style({ height: '0px' })),
  state('*', style({ height: '*' })),
  transition(':enter', animate('500ms ease-out', style({ height: '*' }))),
  transition(':leave', animate('400ms ease-in', style({ height: '0px' })))
])